import { render, staticRenderFns } from "./c5.vue?vue&type=template&id=487e5dc5&scoped=true"
import script from "./c5.vue?vue&type=script&lang=js"
export * from "./c5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487e5dc5",
  null
  
)

export default component.exports